import { render, staticRenderFns } from "./message-controller.vue?vue&type=template&id=09e2e799&scoped=true&"
import script from "./message-controller.vue?vue&type=script&lang=js&"
export * from "./message-controller.vue?vue&type=script&lang=js&"
import style0 from "./message-controller.vue?vue&type=style&index=0&id=09e2e799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2e799",
  null
  
)

export default component.exports